import { Layout } from 'antd';

const LayoutComponent = ({ ...props }) => {
    return <Layout>{props.children}</Layout>;
};

export default LayoutComponent;
